import { RowsWithRefs, RowWithRef } from "PFApp/booking/store";
import { Row } from "PFApp/booking/types";

export const findRowWithRefAtClientY = (
  rowsWithRefs: RowsWithRefs<Row>,
  clientY: number
): RowWithRef<Row> | undefined => {
  for (const rowWithRef of rowsWithRefs.values()) {
    const rect = rowWithRef.rowRef?.getBoundingClientRect();
    if (rect && clientY > rect.top - 1 && clientY < rect.bottom + 1) {
      return rowWithRef;
    }
  }
  return undefined;
};
